import { Injectable, inject } from '@angular/core';
import { HdContentLanguageService } from './hd-content-language.service';

/** Output-pad van de via `angular.json` als asset gekopieerde stream-markdown. */
const HD_STREAMS_ASSET_BASE = '/assets/docs/human-design/streams';

/** Talen waarvoor stream-markdown-assets bestaan; andere talen vallen terug op `nl`. */
const HD_STREAMS_MARKDOWN_LANGS = new Set(['nl', 'en']);

/**
 * Kleine facade voor de markdown-assets van de bewustzijnsstromen (stromen van
 * bewustzijn). Spiegelt {@link HdCircuitInfoService.markdownUrl} maar sterk
 * vereenvoudigd: stromen hebben geen varianten — één `.md` per stream-key.
 *
 * De `<markdown [src]="…">`-component van ngx-markdown doet het laden zelf.
 */
@Injectable({ providedIn: 'root' })
export class HdStreamInfoService {
  private readonly contentLang = inject(HdContentLanguageService);

  /**
   * URL naar het markdown-bestand voor een stream-key. Default-taal is de
   * content-taal (chart-override) met fallback op de actieve app-taal.
   *
   * Engelse stream-bestanden bestaan momenteel **nog niet** — alles valt terug
   * op de Nederlandse versie (mirror van {@link HdCircuitInfoService}). Zodra
   * `en/`-bestanden bijkomen verandert de fallback automatisch mee.
   */
  streamMarkdownUrl(streamKey: string, lang?: string): string {
    const resolved = this.resolveMarkdownLang(lang ?? this.contentLang.effectiveLang());
    return `${HD_STREAMS_ASSET_BASE}/${resolved}/${streamKey}.md`;
  }

  private resolveMarkdownLang(lang: string): string {
    const normalized = (lang || '').toLowerCase().split('-')[0];
    return HD_STREAMS_MARKDOWN_LANGS.has(normalized) ? normalized : 'nl';
  }
}
